import { Button } from 'entities/Button'
import AltRouteIcon from '@mui/icons-material/AltRoute'
import { useGlobalStore } from 'shared/store/globalSlice'
import { useBranchStore } from 'shared/store/branchesSlice'

export const AppTypeSelector = () => {
  const isCCSelected = useGlobalStore().isCCSelected
  const getBranchList = useBranchStore().getBranchList
  const changeIsCCSelected = useGlobalStore().changeIsCCSelected

  const handleAppChange = () => {
    changeIsCCSelected(!isCCSelected)
    getBranchList()
  }

  return (
    <Button
      color='warning'
      width='unset'
      variant={isCCSelected ? 'contained' : 'outlined'}
      //   variant="outlined"
      handleClick={handleAppChange}
    >
      <AltRouteIcon />
      <p style={{ marginLeft: '10px' }}>
        {isCCSelected ? 'Setup QR-Menu' : 'Setup Click & Collect'}
      </p>
    </Button>
  )
}
